import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class SpecialtyVehiclePowersportSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.actionAccent)}
            d="M66.952,53.693a8.557,8.557,0,1,0,8.557,8.557A8.557,8.557,0,0,0,66.952,53.693Zm-.018,11.688a3.261,3.261,0,1,1,3.261-3.261A3.26,3.26,0,0,1,66.934,65.381Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M23.772,54.63a8.558,8.558,0,1,0,8.558,8.558A8.558,8.558,0,0,0,23.772,54.63Zm-.017,11.688a3.261,3.261,0,1,1,3.26-3.26A3.26,3.26,0,0,1,23.755,66.318Z"
          />
          <path
            className={css(styles.grey)}
            d="M74.4,53.891a11.907,11.907,0,0,0-10.28-2.419,12.112,12.112,0,0,0-5.965,3.016l-8.164-8.3.435-1.667-2.194-2.194a13.591,13.591,0,0,0-9.612-3.982H36.156l-10.35,8.939c5.964,5.78,7.412,10.956,7.722,13.73a8.865,8.865,0,0,1,.482,2.212c5.364.92,11.536,2.637,15.437-1.078l1.184-1.126a4.2,4.2,0,0,1,4.643-.772l3.048,1.25.592-1.737c.091-.038.147-.065.147-.065,0-.023.01-.045.014-.068a9.854,9.854,0,0,1,9.191-5.65c6.919,0,9.383,6.337,9.383,6.337C78.1,59.339,76.772,55.961,74.4,53.891Z"
          />
          <path
            className={css(styles.action)}
            d="M48.75,45.58c-.609-6.857-2.41-9.237-2.41-9.237C27.762,31.908,23.577,47.829,23.577,47.829l-2,5.306c-.095.02-.195.028-.289.051-5.287,1-7.773,4.989-7.261,6.294.616,1.566,2.807.538,2.807.538,0-.019.009-.038.012-.056a8.665,8.665,0,0,1,8.1-4.694,9.6,9.6,0,0,1,8.488,5.408c.287-.59-.376-2.309-1.56-3.866,2.355-7.179,12.369-13.343,12.369-13.343l5.972,3.772C50.94,46.844,48.823,46.4,48.75,45.58Z"
          />
          <path
            className={css(styles.action)}
            d="M62.144,43.6c3.248-.45,7.163-.568,8.413,1.162,0,0,1.277,3.879-7.186,7.057a13.939,13.939,0,0,0-2.794,3.349c-1.606,2.389-6.261-5.445-11.609-6.711a11.555,11.555,0,0,1-4.713-2.21c-1.35-1.108-2.177-2.391-.083-3.093s5.386-.354,8.153.169A30.419,30.419,0,0,0,62.144,43.6Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M46.375,36.36s-8.695,3.981-10.791,8.871S30.2,56.876,30.2,56.876l.938.762a23.683,23.683,0,0,1,1.739,2.032l.655,1.361,5.823-12.308,9.227-.3,1.369.38,1.225-2.629s1.055-2.777-1.763-6.81C47.388,36.465,46.375,36.36,46.375,36.36Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M53.117,28.255H44.508a1.244,1.244,0,0,0-.966.468,6.935,6.935,0,0,0-3.713,1.935l-2.366,2.366,1.252,1.253,2.366-2.366a5.189,5.189,0,0,1,2.512-1.391,1.241,1.241,0,0,0,.915.406h8.609a.619.619,0,0,0,.618-.617V28.873A.62.62,0,0,0,53.117,28.255Z"
          />
          <path
            className={css(styles.action)}
            d="M29.816,31.394a4.6,4.6,0,0,0-1.241-.05A3.337,3.337,0,0,1,30.8,35.467a3.365,3.365,0,0,1-3.527,2.862,4.488,4.488,0,0,0,.81.235,4.154,4.154,0,0,0,4.906-2.813A3.693,3.693,0,0,0,29.816,31.394Z"
          />
          <path
            className={css(styles.grey)}
            d="M37.785,31.909h-6.6a3.494,3.494,0,0,1,1.772,3.827,4.155,4.155,0,0,1-4.906,2.814,4.488,4.488,0,0,1-.81-.235c-.066-.009-.132,0-.2-.019a2.848,2.848,0,0,1-1.94-1.6v6.838a2.592,2.592,0,0,0,4.321,1.931l10.087-9.031A2.592,2.592,0,0,0,37.785,31.909Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M25.328,32.41a3.225,3.225,0,0,1,1.47-1.035l-.879-.878a7.028,7.028,0,0,0-1.463-1.116,1.252,1.252,0,0,0-1.232-1.063H15.8a.619.619,0,0,0-.618.617v1.437a.62.62,0,0,0,.618.618h7.429a1.226,1.226,0,0,0,.369-.063,5.292,5.292,0,0,1,1.074.822Z"
          />
          <path
            className={css(styles.grey)}
            d="M85.326,68.97a1.065,1.065,0,0,1,.635,1.395.783.783,0,0,1-.658.436c-5.831.023-12.911-.069-18.454.054.808-.147,1.125-.447,2.036-.7a6.777,6.777,0,0,0,3.08-1.758c.549-.687.365-2.5,2.485-2.5.972,0,.972.669,1.8,1.071a1.048,1.048,0,0,0,1.4-.364c.533-1.027-.09-2,1.064-2.784a2.243,2.243,0,0,1,2.9.523c.653.786.282,1.519,1.073,1.664.726.134.656-.864,1.775-.848a1.5,1.5,0,0,1,1.332,1.943C85.64,67.637,84.188,68.4,85.326,68.97Z"
          />
        </g>
      </svg>
    );
  }
}
